import classnames from 'classnames';
import React, {useContext} from 'react';
import {useSelector} from 'react-redux';
import {Store} from 'src/types/store';
import Avatar from 'shared/components/avatar';
import {useBoolean} from 'src/hooks/useBoolean';
import {useMediaQuery} from 'src/hooks/useMediaQuery';
import {UserType} from 'src/types/enums';
import AboutMeForm from 'src/views/high-school/about-me-form';
import Bio from 'src/views/high-school/bio';
import {PlatformContext} from '../../components/PlatformContext';

const HighSchoolAboutMe = () => {
  const editing = useBoolean(false);
  const mq = useMediaQuery();
  const platformContext = useContext(PlatformContext);
  const student = useSelector((state: Store) => state.student);

  return (
    <div
      className={classnames('about-me', {
        'ionic-about-me': mq.MS_AND_DOWN && platformContext.isIonic,
      })}
    >
      <div className="about-me-avatar" data-testid="about-me-avatar">
        <Avatar image={student.image} editing={editing.value} userType={UserType.HS_STUDENT} />
      </div>
      <div className="about-me-wrapper" data-testid="about-me-wrapper">
        {editing.value ? (
          <AboutMeForm
            setEditingFalse={editing.setFalse}
            name={`${student.firstName} ${student.lastName}`}
          />
        ) : (
          <Bio onClick={editing.setTrue} student={student} />
        )}
      </div>
    </div>
  );
};

export default HighSchoolAboutMe;
